var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SuggestPart',_vm._g(_vm._b({attrs:{"item-value":"id","item-text":(Item) => {
      return this.$moment(Item.paidAt).format('DD.MM.YYYY') + ' - ' + Item.title + ' (' + this.$options.filters.currency(Item.balance, '€') + ')'
    },"itemsKey":"expenses","fetchData":_vm.fetchData}},'SuggestPart',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }